module.exports = __webpack_public_path__ + "static/13.3_the_rise_of_rome-8bd5e5b937999777b8b4ee5746a35762.pdf";